import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LaunchIcon from '@material-ui/icons/Launch';

import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Link from "@material-ui/core/Link";

/** 
    Implements a dropdown using Material UI
    mostly lifted from
    https://material-ui.com/components/button-group/
    (they call it a "Split button")

    This component always shows a dropdown menu - even if a single item is passed. 
    @See 
*/

export const DropdownButton = ({text, items=[], order, onClick = (id, text, url) => {}}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleClick = (id, text, url) => {
    setOpen(false);
    onClick && onClick(id, text, url)
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // note: this format of using "link" comes from the data for Listicle MENU items
  items = items.filter((item) => {
    return item.id && item.link && item.label
  })

  return (
        <div className="content-item dropdown-button" style={{order: order}}>

        <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button" className={`themed-button-group`}>
          <Button onClick={handleToggle} className={`themed-button`}>{text}</Button>
          <Button
            color="primary"
            size="small"
            className={`themed-button themed-button-toggle`}
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper className="popper" open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" className={`themed-menu`}>
                    {items.map((item, index) => (
                      <MenuItem
                        key={index}
                        // onClick={(event) => handleClick }
                        onClick={(event) => {
                            // need to use this syntax to hoist up handleClick()
                            handleClick(item.id, item.label, item.link)
                        } }
                        component={Link}
                        href={item.link}
                        target="_blank"
                        className={`themed-menu-link`}
                      >
                        {item.label}
                        <LaunchIcon />
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>


        </div>
  );
}